import { useEffect, useState } from 'react'

/**
 * Bir elemanın CANLI yüksekliği (px) — ResizeObserver ile.
 *
 * Sol ikon rayı buna göre ikon boyutunu küçültür: modül sayısı arttıkça (ya da
 * ekran kısaldıkça) sabit boyutlu ikonlar taşıp rayı kaydırmalı yapıyordu —
 * kullanıcı alttaki modülleri göremiyordu (2026-09-17 bildirimi).
 *
 * `useElementWidth` ile aynı desen; ikisi ayrı tutuldu çünkü çağıranlar yalnız
 * birini izliyor ve gereksiz yeniden render istemiyoruz.
 *
 * Gözlemci yoksa (çok eski tarayıcı) 0 döner; çağıran taraf bunu "bilinmiyor"
 * sayıp en GENİŞ varsayıma düşmelidir — küçültmemek, yanlış küçültmekten iyidir.
 */
export function useElementHeight(ref) {
  const [height, setHeight] = useState(0)
  useEffect(() => {
    const el = ref?.current
    if (!el || typeof ResizeObserver === 'undefined') return undefined
    // ⚠️ İlk ölçüm ile gözlemci AYNI kutuyu ölçmeli (border-box) ve tam sayıya
    // yuvarlanmalı. Eskiden ilk değer getBoundingClientRect (dolgu dahil), sonrakiler
    // contentRect (dolgu ve kaydırma çubuğu HARİÇ) idi; küsurat farkları da her seferinde
    // yeniden render tetikliyordu → sol rayda titreme döngüsü (13.10.2026).
    const read = () => Math.round(el.getBoundingClientRect().height)
    setHeight(read())
    const ro = new ResizeObserver(() => {
      const h = read()
      if (h) setHeight((prev) => (Math.abs(prev - h) >= 1 ? h : prev))
    })
    ro.observe(el)
    return () => ro.disconnect()
  }, [ref])
  return height
}
